function utf8Encode(value) {
	if (typeof TextEncoder === "function") {
		return new TextEncoder().encode(String(value || ""))
	}

	return Uint8Array.from(unescape(encodeURIComponent(String(value || ""))), (char) => char.charCodeAt(0))
}

function utf8Decode(bytes) {
	let binary = ""
	let chunkSize = 0x8000

	if (typeof TextDecoder === "function") {
		return new TextDecoder().decode(bytes)
	}

	for (let index = 0; index < bytes.length; index += chunkSize) {
		let chunk = bytes.subarray(index, index + chunkSize)
		binary += String.fromCharCode.apply(null, chunk)
	}

	return decodeURIComponent(escape(binary))
}

function bytesToBase64(bytes) {
	let binary = ""
	let chunkSize = 0x8000

	for (let index = 0; index < bytes.length; index += chunkSize) {
		let chunk = bytes.subarray(index, index + chunkSize)
		binary += String.fromCharCode.apply(null, chunk)
	}

	return btoa(binary)
}

function base64ToBytes(base64String = "") {
	let binary = atob(base64String)
	return Uint8Array.from(binary, (char) => char.charCodeAt(0))
}

function encodeGenogramJsonBase64(value) {
	let jsonString = typeof value === "string" ? value : JSON.stringify(value)
	return bytesToBase64(utf8Encode(jsonString))
}

function decodeGenogramJsonBase64(base64String = "") {
	if (!base64String) {
		return null
	}

	let decodedString = utf8Decode(base64ToBytes(base64String))
	let parsedValue = null

	try {
		parsedValue = JSON.parse(decodedString)
	} catch (error) {
		parsedValue = JSON.parse(decodeURIComponent(decodedString))
	}

	if (!parsedValue || Array.isArray(parsedValue) || typeof parsedValue !== "object") {
		throw new Error("genogramJsonBase64 must decode to a JSON object")
	}

	return parsedValue
}

export {
	decodeGenogramJsonBase64,
	encodeGenogramJsonBase64,
}
